import React from 'react';
import { motion } from 'framer-motion';

export default function BrowserMockup({ src, alt, delay = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay }}
      className="rounded-xl border border-slate-200 bg-white shadow-2xl overflow-hidden"
    >
      {/* Browser chrome */}
      <div className="flex items-center gap-2 px-4 py-3 bg-slate-100 border-b border-slate-200">
        <div className="flex gap-1.5">
          <div className="w-3 h-3 rounded-full bg-red-400" />
          <div className="w-3 h-3 rounded-full bg-amber-400" />
          <div className="w-3 h-3 rounded-full bg-emerald-400" />
        </div>
        <div className="flex-1 flex justify-center">
          <div className="bg-white rounded-md px-4 py-1 text-xs text-slate-400 border border-slate-200 max-w-xs w-full text-center truncate">
            wc360.base44.app
          </div>
        </div>
      </div>
      {/* Screenshot */}
      <img src={src} alt={alt} className="w-full h-auto block" />
    </motion.div>
  );
}